module.exports = __webpack_public_path__ + "static/img/QQ.e3c0580.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QQ.png
// module id = hi//
// module chunks = 12